import { Table } from '@shared/Table'
import React from 'react'
import { columns as defaultColumns } from '../../../../../constants/orderdetailhistory.columns'
import { useFetchOrderDetailsMutation } from 'store/reducers/salaryCards/orderDetails.api'
const OrderHistoryTable = () => {
  const [_, { data: detailInformationList, isSuccess }] =
    useFetchOrderDetailsMutation({ fixedCacheKey: 'fetchOrderDetails' })

  const columns = defaultColumns()
  return (
    <>
      <Table
        tableKey="orderHistoryTable"
        bordered
        editColumns={columns}
        dataSource={
          isSuccess ? detailInformationList.orderSalaryCardHistories : []
        }
        pagination={false}
        size="small"
      />
    </>
  )
}

export default OrderHistoryTable
